import hsm from '@/plugins/hsm.plugin'
// import { getSafe } from '@/plugins/globals.plugin'

const HSM_SDK = [
  {
    state: 'logCacheState',
    stateDefault: null,
    mutation: 'SET_LOG_CACHE',
    action: 'getLogCacheState'
  },
  {
    state: 'p11Info',
    stateDefault: null,
    mutation: 'SET_P11_INFO',
    action: 'getP11Info'
  },
  {
    state: 'copyrightInfo',
    stateDefault: null,
    mutation: 'SET_COPYRIGHT_INFO',
    action: 'getCopyrightInfo'
  },
  {
    state: 'probe',
    stateDefault: null,
    mutation: 'SET_PROBE',
    action: 'getProbe'
  },
  {
    state: 'sessions',
    stateDefault: null,
    mutation: 'SET_SESSIONS',
    action: 'getSessions'
  },
  {
    state: 'loadedMods',
    stateDefault: null,
    mutation: 'SET_LOADED_MODS',
    action: 'getLoadedMods'
  },
  {
    state: 'sysHealth',
    stateDefault: null,
    mutation: 'SET_SYS_HEALTH',
    action: 'getSysHealth'
  },
  {
    state: 'logSize',
    stateDefault: null,
    mutation: 'SET_LOG_SIZE',
    action: 'getLogSize'
  },
  {
    state: 'netInfo',
    stateDefault: {
      interfaces: [],
      snmp: {
        community: '',
        sys_contact: '',
        sys_location: '',
        targets: []
      }
    },
    mutation: 'SET_NET_INFO',
    action: 'getNetInfo'
  },
  {
    state: 'ipFilter',
    stateDefault: {
      enabled: 0,
      filters: []
    },
    mutation: 'SET_IP_FILTER',
    action: 'getIpFilter'
  },
  {
    state: 'aTokenList',
    stateDefault: [],
    mutation: 'SET_ATOKEN_LIST',
    action: 'getAtokenList'
  },
  {
    state: 'listObjects',
    stateDefault: [],
    mutation: 'SET_LIST_OBJECTS',
    action: 'getListObjects'
  },
  {
    state: 'statInfo',
    stateDefault: null,
    mutation: 'SET_STAT_INFO',
    action: 'getStatInfo'
  },
  {
    state: 'acl',
    stateDefault: null,
    mutation: 'SET_ACL',
    action: 'getAcl'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'updateAcl'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'setIpFilter'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'addIpFilter'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'delIpFilter'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'truncateLog'
  },
  {
    state: 'backup',
    stateDefault: null,
    mutation: 'SET_BACKUP',
    action: 'getBackup'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'changePwd'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'replNodeMsg'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'replPulse'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'unpackPush'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'restoreBackup'
  },
  {
    state: 'rand',
    stateDefault: null,
    mutation: 'SET_RAND',
    action: 'genRand',
    actionParams: { body: { len: 16 } }
  },
  {
    state: 'nsAuth',
    stateDefault: null,
    mutation: 'SET_NS_AUTH',
    action: 'getNsAuth'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'delAuthSa'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'newOathAuthSa'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'newX509AuthSa'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'aTokenIssue'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'aTokenRevoke'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'delObject'
  },
  {
    state: 'objectInfo',
    stateDefault: null,
    mutation: 'SET_OBJECT_INFO',
    action: 'getObjectInfo',
    actionParams: { body: { id: 0 } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'blockObject'
  },
  {
    state: 'p11Manager',
    stateDefault: null,
    mutation: 'SET_P11_MANAGER',
    action: 'p11ManagerGet',
    actionParams: { body: { id: 0 } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'p11ManagerDel'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'p11ManagerUpdate'
  },
  {
    state: 'objectSP80057',
    stateDefault: null,
    mutation: 'SET_OBJECT_SP80057',
    action: 'getObjectSP80057',
    actionParams: { body: { id: 0 } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'createKey'
  },
  {
    state: 'mapInfo',
    stateDefault: null,
    mutation: 'SET_MAP_INFo',
    action: 'getMapInfo',
    actionParams: { body: { obj: 0 } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'newMap'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'setSysDate'
  },
  {
    state: 'tlsBundle',
    stateDefault: null,
    mutation: 'SET_TLS_BUNDLE',
    action: 'setTlsBundle',
    actionParams: { body: { key: 0, cert: 0 } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bindDS',
    actionParams: { body: { token: '' } }
  },
  {
    state: null,
    action: 'netTools',
    actionParams: { body: { tool: 1, target: '' } }
  },
  {
    state: null,
    action: 'getCrossCheck'
  },
  {
    state: 'objectStatistic',
    stateDefault: null,
    mutation: 'SET_OBJECT_STATISTIC',
    action: 'getObjectStatistic',
    actionParams: { body: { id: 0 } }
  },
  {
    state: 'slObjectStatistic',
    stateDefault: null,
    mutation: 'SET_SL_OBJECT_STATISTIC',
    action: 'getSLObjectStatistic'
  },
  {
    state: null,
    action: 'getKcvOrCmac',
    actionParams: { body: { type: 0, key: '' } }
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'set_snmp_config'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'enable_ntp'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'update_ntp'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'set_dns'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'set_syslog_rh'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchainBip32XprvCreate'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_export'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_get_addr'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_import'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_kinfo'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_bip32_xprv_derive'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_get_pbk'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'bchain_hash'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'skeep_new_secret'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'skeep_split_secret'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'skeep_probe_secret'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'skeep_match_secret'
  },
  {
    state: null,
    stateDefault: null,
    mutation: null,
    action: 'skeep_del_secret'
  }
]

const state = {
  instance: null,
  upackUploadProgress: null,
  restoreBackupProgress: null,
  restoreBackupReq: null,
  restoreUpackReq: null,
  loading: false,
  error: {
    status: false,
    message: null
  }
}

const getters = {
  GET_P11_INFO_PROP: state => (prop) => {
    if (state.p11Info && Object.prototype.hasOwnProperty.call(state.p11Info, prop)) return state.p11Info[prop]
    else return null
  },
  GET_INFO: state => {
    const statInfo = state.statInfo
    const logCacheState = state.logCacheState
    const p11Info = state.p11Info
    const loadedMods = state.loadedMods
    const filter = { filter: state.ipFilter }
    const sysHealth = state.sysHealth
    const netInfo = state.netInfo

    if (statInfo) {
      const obj = {
        ...statInfo,
        ...p11Info,
        ...loadedMods,
        ...netInfo,
        ...filter,
        ...sysHealth,
        logCacheState
      }
      return obj
    }
  }
}

const mutations = {
  SET_INSTANCE (state) {
    state.instance = hsm.getInstance()
  },
  SET_UPACK_REQ (state, payload) {
    state.restoreUpackReq = payload
  },
  SET_RESTORE_BACKUP_REQ (state, payload = null) {
    state.restoreBackupReq = payload
  },
  RENEW_INSTANCE (state) {
    state.instance = hsm.getInstance(true)
  },
  SET_LOADING (state, payload = false) {
    state.loading = payload
  },
  SET_ERROR (state, { status = true, message = null }) {
    state.error.status = status
    state.error.message = message
  },
  SET_upackUploadProgress (state, payload = false) {
    state.upackUploadProgress = payload
  },
  SET_restoreBackupProgress (state, payload = null) {
    state.restoreBackupProgress = payload
  },
  CLEAR_ERROR (state) {
    state.error.status = false
    state.error.message = null
  }
}

const actions = {
  init ({ commit }) {
    commit('SET_INSTANCE')
  },
  updateFirmware ({ state, commit, dispatch, rootState }, file) {
    return new Promise((resolve, reject) => {
      try {
        const req = rootState.hsm.instance.getFirmwareUpdate()
        commit('SET_UPACK_REQ', req)
        state.restoreUpackReq
          .set('Content-Type', 'application/octet-stream')
          .responseType('blob')
          .send(file)
          .on('progress', () => {
            commit('SET_upackUploadProgress', event.percent)
          })
          .then(() => {
            resolve()
          })
          .catch(err => {
            const reader = new FileReader()
            if (!err.response || !err.response.body) {
              return reject(err)
            }
            reader.onloadend = function () {
              return reject(JSON.parse(reader.result))
            }
            reader.readAsText(err.response.body)
          })
          .finally(() => {
            commit('SET_upackUploadProgress', null)
          })
      } catch (err) {
        dispatch('error/setError', { error: err }, { root: true })

        reject(err)
      }
    })
  },
  abortFirmwareUpdate ({ state, commit }) {
    if (state.restoreUpackReq !== null) {
      state.restoreUpackReq.abort()
      commit('SET_UPACK_REQ', null)
    }
  },
  restoreBackupHSM (
    { state, commit, dispatch, rootState },
    { pwd, restore, file }
  ) {
    return new Promise((resolve, reject) => {
      try {
        const req = rootState.hsm.instance.getRestore()
        commit('SET_RESTORE_BACKUP_REQ', req)

        state.restoreBackupReq
          .set('HSM-Upload-CSP', `${pwd}:${restore ? '0' : '1'}`)
          .set('Content-Type', 'application/octet-stream')
          .responseType('blob')
          .send(file)
          .on('progress', event => {
            commit('SET_restoreBackupProgress', event.percent)
          })
          .then(res => {
            return resolve(res)
          })
          .catch(err => {
            const reader = new FileReader()

            reader.onloadend = function () {
              return reject(JSON.parse(reader.result))
            }
            reader.readAsText(err.response.body)
          })
          .finally(() => {
            commit('SET_restoreBackupProgress', null)
          })
      } catch (err) {
        dispatch('error/setError', { error: err }, { root: true })

        reject(err)
      }
    })
  },
  abortRestoreBackup ({ state, commit }) {
    if (state.restoreBackupReq !== null) {
      state.restoreBackupReq.abort()
      commit('SET_RESTORE_BACKUP_REQ')
    }
  },
  getBackupSubmit ({ rootState }, param) {
    const authToken = rootState.hsm.instance.authToken
    // param = Object.assign(param || {}, { 'hsm-authorization': sessionStorage.getItem('authToken') })
    param = Object.assign(param || {}, { 'hsm-authorization': authToken })

    const form = document.createElement('form')

    form.setAttribute('method', 'post')
    form.setAttribute('target', 'hidden-form')
    form.setAttribute('enctype', 'text/plain')
    form.setAttribute(
      'action',
      process.env.VUE_APP_HSM_API_BASE + '/get_backup'
    )

    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', 'json')
    hiddenField.setAttribute('value', JSON.stringify(param))

    form.appendChild(hiddenField)

    document.body.appendChild(form)
    return form
    // form.submit()
  },
  async getLogSubmit ({ rootState }, param) {
    const authToken = rootState.hsm.instance.authToken
    // param = Object.assign(param || {}, { 'hsm-authorization': sessionStorage.getItem('authToken') })
    param = Object.assign(param || {}, { 'hsm-authorization': authToken })

    const form = document.createElement('form')
    form.setAttribute('method', 'post')
    form.setAttribute('target', 'hidden-form')
    form.setAttribute('enctype', 'text/plain')
    form.setAttribute('action', process.env.VUE_APP_HSM_API_BASE + '/get_log')

    const hiddenField = document.createElement('input')
    hiddenField.setAttribute('type', 'hidden')
    hiddenField.setAttribute('name', 'json')
    hiddenField.setAttribute('value', JSON.stringify(param))

    form.appendChild(hiddenField)

    document.body.appendChild(form)
    form.submit()
  },
  async getInfo ({ commit, dispatch }) {
    try {
      const res = await Promise.all([
        state.instance.getP11Info(),
        state.instance.getStatInfo(),
        state.instance.getLoadedMods(),
        state.instance.getNetInfo(),
        state.instance.getIpFilter(),
        state.instance.getSysHealth(),
        state.instance.getLogSize(),
        state.instance.getLogCacheState()
      ])

      commit('SET_P11_INFO', res[0])
      commit('SET_STAT_INFO', res[1])
      commit('SET_LOADED_MODS', res[2])
      commit('SET_NET_INFO', res[3])
      commit('SET_IP_FILTER', res[4])
      commit('SET_SYS_HEALTH', res[5])
      commit('SET_LOG_CACHE', res[6])
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  },
  async setLogCache ({ state, dispatch }, { body }) {
    const hsm = state.instance

    try {
      const res = await hsm.setLogCache({ body })
      return res
    } catch (err) {
      dispatch('error/setError', { error: err }, { root: true })
      throw err
    }
  }
}

HSM_SDK.forEach(item => {
  if (item.state) state[item.state] = item.stateDefault

  if (item.mutation) {
    mutations[item.mutation] = function (state, payload) {
      state[item.state] = payload
    }
  }

  if (item.action) {
    actions[item.action] = function (
      { state, commit, dispatch },
      body = item.actionParams || {}
    ) {
      return new Promise((resolve, reject) => {
        (async () => {
          try {
            const res = await state.instance[item.action](body)
            if (item.mutation) {
              commit(`${item.mutation}`, res)
            }
            return resolve(res)
          } catch (err) {
            dispatch('error/setError', { error: err }, { root: true })
            return reject(err)
          }
        })()
      })
    }
  }
})

export { state, getters, mutations, actions }
